// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type GlobalOptionsIconsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.GlobalOptionsFilter>;
}>;


export type GlobalOptionsIconsQuery = { __typename?: 'Query', globalOptions: Array<{ __typename?: 'GlobalOption', id: string, designUpgradeIconName?: string | null | undefined }> };


export const GlobalOptionsIconsDocument = gql`
    query GlobalOptionsIcons($filter: GlobalOptionsFilter) {
  globalOptions(filter: $filter) {
    id
    designUpgradeIconName
  }
}
    `;

/**
 * __useGlobalOptionsIconsQuery__
 *
 * To run a query within a React component, call `useGlobalOptionsIconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGlobalOptionsIconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGlobalOptionsIconsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGlobalOptionsIconsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>(GlobalOptionsIconsDocument, options);
      }
export function useGlobalOptionsIconsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>(GlobalOptionsIconsDocument, options);
        }
export function useGlobalOptionsIconsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>(GlobalOptionsIconsDocument, options);
        }
export type GlobalOptionsIconsQueryHookResult = ReturnType<typeof useGlobalOptionsIconsQuery>;
export type GlobalOptionsIconsLazyQueryHookResult = ReturnType<typeof useGlobalOptionsIconsLazyQuery>;
export type GlobalOptionsIconsSuspenseQueryHookResult = ReturnType<typeof useGlobalOptionsIconsSuspenseQuery>;
export type GlobalOptionsIconsQueryResult = Apollo.QueryResult<GlobalOptionsIconsQuery, GlobalOptionsIconsQueryVariables>;